import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import { reportService } from "../../../Services/report.service";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";

const InvoicesList = (props) => {
  const { t: translator } = useTranslation();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const { isMobile } = useContext(GlobalContext);

  useEffect(() => {
    reportService
      .invoicesConclusionInvoices({
        guid: props.guid,
        pageIndex: 0,
        pageSize: 0,
      })
      .then((res) => {
        setData(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, []);

  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(row?.issued),
    }).format(Number(cell));
  }

  function documentNumberFormatter(cell, row) {
    return `${cell}/${row.storeTag}/${row.posTag}`;
  }
  function boolFormatter(cell, row) {
    return cell === null ? "Ne" : "Da";
  }

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }

  const columns = [
    {
      dataField: "documentNumber",
      text: translator("Report-View-TableHeader-DocumentNumber"),
      formatter: documentNumberFormatter,
      footer: "Total",
    },
    {
      dataField: "issued",
      text: translator("Report-View-TableHeader-Issued"),
      formatter: dateTimeFormatter,
      footer: "",
      hidden: Boolean(isMobile),
    },
    {
      dataField: "jirTime",
      text: translator("Fisk"),
      formatter: boolFormatter,
      footer: "",
      hidden: Boolean(isMobile),
    },
    {
      dataField: "payValue",
      text: translator("Report-View-TableHeader-PayValue"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      footer: (columnData) =>
        new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(props.date),
        }).format(
          Number(
            columnData.reduce((acc, item) => Number(acc) + Number(item), 0)
          )
        ),
      footerAlign: (column, colIndex) => "right",
    },
  ];

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 mb-4 col-lg-10">
          {!isLoading && (
            <BootstrapTable
              keyField="invoiceGuid"
              data={data}
              loading
              columns={columns}
              ignoreSinglePage={true}
              options={{}}
              classes={"table-sm"}
              rowClasses="boostrap-table-row"
              noDataIndication={translator("No-Data")}
              pagination={
                data.length > 10
                  ? paginationFactory({
                      hideSizePerPage: true,
                      totalSize: data.length,
                      sizePerPage: 10,
                    })
                  : null
              }
              footerClasses={"footer-background"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoicesList;
